/**
 * @generated SignedSource<<c86117baa99f05f41dd6c7a45d8835c8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterBooleanOperator = "AND" | "NOT" | "OR" | "%future added value";
export type FilterElementInput = {
  multiple?: FilterBooleanOperationInput | null | undefined;
  single?: FilterValueInput | null | undefined;
};
export type FilterValueInput = {
  name: string;
  operator?: string | null | undefined;
  value?: string | null | undefined;
  values?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type FilterBooleanOperationInput = {
  operands: ReadonlyArray<FilterElementInput>;
  operator: FilterBooleanOperator;
};
export type RulesFiltersQuery$variables = {
  resourceCriteriaTagValuesFilter?: FilterElementInput | null | undefined;
  resourceTagValuesFilter?: FilterElementInput | null | undefined;
};
export type RulesFiltersQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AccountCriteria_accountGroups" | "AccountCriteria_accounts" | "AccountCriteria_tagKeys" | "AccountCriteria_tagValues" | "BindingCriteria_bindings" | "PolicyCriteria_categories" | "PolicyCriteria_policies" | "PolicyCriteria_policyCollections" | "PolicyCriteria_severities" | "ResourceCriteria_resourceTypes" | "ResourceCriteria_tagKeys" | "ResourceCriteria_tagValues" | "useResourceMatchCount_query">;
};
export type RulesFiltersQuery = {
  response: RulesFiltersQuery$data;
  variables: RulesFiltersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resourceCriteriaTagValuesFilter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resourceTagValuesFilter"
},
v2 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v3 = [
  (v2/*:: as any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = [
  "filterElement"
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v11 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ResourceTagKeyEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ResourceTagKey",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v10/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/)
        ],
        "storageKey": null
      },
      (v7/*:: as any*/)
    ],
    "storageKey": null
  },
  (v8/*:: as any*/)
],
v12 = [
  {
    "kind": "Variable",
    "name": "filterElement",
    "variableName": "resourceTagValuesFilter"
  },
  (v2/*:: as any*/)
],
v13 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ResourceTagValueEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ResourceTagValue",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          },
          (v5/*:: as any*/),
          (v6/*:: as any*/)
        ],
        "storageKey": null
      },
      (v7/*:: as any*/)
    ],
    "storageKey": null
  },
  (v8/*:: as any*/)
],
v14 = [
  {
    "kind": "Variable",
    "name": "filterElement",
    "variableName": "resourceCriteriaTagValuesFilter"
  },
  (v2/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RulesFiltersQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "AccountCriteria_accountGroups"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "AccountCriteria_accounts"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "AccountCriteria_tagKeys"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "resourceTagValuesFilter"
          }
        ],
        "kind": "FragmentSpread",
        "name": "AccountCriteria_tagValues"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "BindingCriteria_bindings"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "PolicyCriteria_categories"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "PolicyCriteria_policies"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "PolicyCriteria_policyCollections"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "PolicyCriteria_severities"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ResourceCriteria_resourceTypes"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ResourceCriteria_tagKeys"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "resourceCriteriaTagValuesFilter"
          }
        ],
        "kind": "FragmentSpread",
        "name": "ResourceCriteria_tagValues"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "useResourceMatchCount_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "RulesFiltersQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "AccountGroupConnection",
        "kind": "LinkedField",
        "name": "accountGroups",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountGroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountGroup",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*:: as any*/),
                  (v5/*:: as any*/),
                  (v6/*:: as any*/)
                ],
                "storageKey": null
              },
              (v7/*:: as any*/)
            ],
            "storageKey": null
          },
          (v8/*:: as any*/)
        ],
        "storageKey": "accountGroups(first:100)"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "filters": (v9/*:: as any*/),
        "handle": "connection",
        "key": "AccountCriteria__accountGroups",
        "kind": "LinkedHandle",
        "name": "accountGroups"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "AccountConnection",
        "kind": "LinkedField",
        "name": "accounts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Account",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v10/*:: as any*/),
                  (v4/*:: as any*/),
                  (v5/*:: as any*/),
                  (v6/*:: as any*/)
                ],
                "storageKey": null
              },
              (v7/*:: as any*/)
            ],
            "storageKey": null
          },
          (v8/*:: as any*/)
        ],
        "storageKey": "accounts(first:100)"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "filters": (v9/*:: as any*/),
        "handle": "connection",
        "key": "AccountCriteria__accounts",
        "kind": "LinkedHandle",
        "name": "accounts"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "ResourceTagKeyConnection",
        "kind": "LinkedField",
        "name": "resourceTagKeys",
        "plural": false,
        "selections": (v11/*:: as any*/),
        "storageKey": "resourceTagKeys(first:100)"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "filters": (v9/*:: as any*/),
        "handle": "connection",
        "key": "AccountCriteria__resourceTagKeys",
        "kind": "LinkedHandle",
        "name": "resourceTagKeys"
      },
      {
        "alias": null,
        "args": (v12/*:: as any*/),
        "concreteType": "ResourceTagValueConnection",
        "kind": "LinkedField",
        "name": "resourceTagValues",
        "plural": false,
        "selections": (v13/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v12/*:: as any*/),
        "filters": (v9/*:: as any*/),
        "handle": "connection",
        "key": "AccountCriteria__resourceTagValues",
        "kind": "LinkedHandle",
        "name": "resourceTagValues"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "BindingConnection",
        "kind": "LinkedField",
        "name": "bindings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BindingEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Binding",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "uuid",
                    "storageKey": null
                  },
                  (v4/*:: as any*/),
                  (v5/*:: as any*/),
                  (v6/*:: as any*/)
                ],
                "storageKey": null
              },
              (v7/*:: as any*/)
            ],
            "storageKey": null
          },
          (v8/*:: as any*/)
        ],
        "storageKey": "bindings(first:100)"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "filters": (v9/*:: as any*/),
        "handle": "connection",
        "key": "BindingCriteria__bindings",
        "kind": "LinkedHandle",
        "name": "bindings"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "PolicyCategoryValueConnection",
        "kind": "LinkedField",
        "name": "policyCategoryValues",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PolicyCategoryValueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PolicyCategoryValue",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "category",
                    "storageKey": null
                  },
                  (v6/*:: as any*/)
                ],
                "storageKey": null
              },
              (v7/*:: as any*/)
            ],
            "storageKey": null
          },
          (v8/*:: as any*/)
        ],
        "storageKey": "policyCategoryValues(first:100)"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "filters": (v9/*:: as any*/),
        "handle": "connection",
        "key": "PolicyCriteria__policyCategoryValues",
        "kind": "LinkedHandle",
        "name": "policyCategoryValues"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "PolicyConnection",
        "kind": "LinkedField",
        "name": "policies",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PolicyEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Policy",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*:: as any*/),
                  (v4/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "unqualifiedName",
                    "storageKey": null
                  },
                  (v6/*:: as any*/)
                ],
                "storageKey": null
              },
              (v7/*:: as any*/)
            ],
            "storageKey": null
          },
          (v8/*:: as any*/)
        ],
        "storageKey": "policies(first:100)"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "filters": (v9/*:: as any*/),
        "handle": "connection",
        "key": "PolicyCriteria__policies",
        "kind": "LinkedHandle",
        "name": "policies"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "PolicyCollectionConnection",
        "kind": "LinkedField",
        "name": "policyCollections",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PolicyCollectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PolicyCollection",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*:: as any*/),
                  (v4/*:: as any*/),
                  (v6/*:: as any*/)
                ],
                "storageKey": null
              },
              (v7/*:: as any*/)
            ],
            "storageKey": null
          },
          (v8/*:: as any*/)
        ],
        "storageKey": "policyCollections(first:100)"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "filters": (v9/*:: as any*/),
        "handle": "connection",
        "key": "PolicyCriteria__policyCollections",
        "kind": "LinkedHandle",
        "name": "policyCollections"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "PolicySeverityValueConnection",
        "kind": "LinkedField",
        "name": "policySeverityValues",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PolicySeverityValueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PolicySeverityValue",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "severity",
                    "storageKey": null
                  },
                  (v6/*:: as any*/)
                ],
                "storageKey": null
              },
              (v7/*:: as any*/)
            ],
            "storageKey": null
          },
          (v8/*:: as any*/)
        ],
        "storageKey": "policySeverityValues(first:100)"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "filters": (v9/*:: as any*/),
        "handle": "connection",
        "key": "PolicyCriteria__policySeverityValues",
        "kind": "LinkedHandle",
        "name": "policySeverityValues"
      },
      {
        "alias": "resourceCriteriaTypes",
        "args": (v3/*:: as any*/),
        "concreteType": "ResourceTypeConnection",
        "kind": "LinkedField",
        "name": "resourceTypes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ResourceTypeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ResourceType",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "qualifiedName",
                    "storageKey": null
                  },
                  (v5/*:: as any*/),
                  (v6/*:: as any*/)
                ],
                "storageKey": null
              },
              (v7/*:: as any*/)
            ],
            "storageKey": null
          },
          (v8/*:: as any*/)
        ],
        "storageKey": "resourceTypes(first:100)"
      },
      {
        "alias": "resourceCriteriaTypes",
        "args": (v3/*:: as any*/),
        "filters": (v9/*:: as any*/),
        "handle": "connection",
        "key": "ResourceCriteria__resourceCriteriaTypes",
        "kind": "LinkedHandle",
        "name": "resourceTypes"
      },
      {
        "alias": "resourceCriteriaTagKeys",
        "args": (v3/*:: as any*/),
        "concreteType": "ResourceTagKeyConnection",
        "kind": "LinkedField",
        "name": "resourceTagKeys",
        "plural": false,
        "selections": (v11/*:: as any*/),
        "storageKey": "resourceTagKeys(first:100)"
      },
      {
        "alias": "resourceCriteriaTagKeys",
        "args": (v3/*:: as any*/),
        "filters": (v9/*:: as any*/),
        "handle": "connection",
        "key": "ResourceCriteria__resourceCriteriaTagKeys",
        "kind": "LinkedHandle",
        "name": "resourceTagKeys"
      },
      {
        "alias": "resourceCriteriaTagValues",
        "args": (v14/*:: as any*/),
        "concreteType": "ResourceTagValueConnection",
        "kind": "LinkedField",
        "name": "resourceTagValues",
        "plural": false,
        "selections": (v13/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": "resourceCriteriaTagValues",
        "args": (v14/*:: as any*/),
        "filters": (v9/*:: as any*/),
        "handle": "connection",
        "key": "ResourceCriteria__resourceCriteriaTagValues",
        "kind": "LinkedHandle",
        "name": "resourceTagValues"
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 1
          }
        ],
        "concreteType": "ResourceMatchConnection",
        "kind": "LinkedField",
        "name": "resourceMatches",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "total",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "resourceMatches(first:1)"
      }
    ]
  },
  "params": {
    "cacheID": "137527c34919a4033bee768c09bf3a33",
    "id": null,
    "metadata": {},
    "name": "RulesFiltersQuery",
    "operationKind": "query",
    "text": "query RulesFiltersQuery(\n  $resourceTagValuesFilter: FilterElementInput\n  $resourceCriteriaTagValuesFilter: FilterElementInput\n) {\n  ...AccountCriteria_accountGroups\n  ...AccountCriteria_accounts\n  ...AccountCriteria_tagKeys\n  ...AccountCriteria_tagValues_1U2ptx\n  ...BindingCriteria_bindings\n  ...PolicyCriteria_categories\n  ...PolicyCriteria_policies\n  ...PolicyCriteria_policyCollections\n  ...PolicyCriteria_severities\n  ...ResourceCriteria_resourceTypes\n  ...ResourceCriteria_tagKeys\n  ...ResourceCriteria_tagValues_2yVqzf\n  ...useResourceMatchCount_query\n}\n\nfragment AccountCriteria_accountGroups on Query {\n  accountGroups(first: 100) {\n    edges {\n      node {\n        name\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AccountCriteria_accounts on Query {\n  accounts(first: 100) {\n    edges {\n      node {\n        key\n        name\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AccountCriteria_tagKeys on Query {\n  resourceTagKeys(first: 100) {\n    edges {\n      node {\n        key\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AccountCriteria_tagValues_1U2ptx on Query {\n  resourceTagValues(first: 100, filterElement: $resourceTagValuesFilter) {\n    edges {\n      node {\n        value\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment BindingCriteria_bindings on Query {\n  bindings(first: 100) {\n    edges {\n      node {\n        uuid\n        name\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment PolicyCriteria_categories on Query {\n  policyCategoryValues(first: 100) {\n    edges {\n      node {\n        id\n        category\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment PolicyCriteria_policies on Query {\n  policies(first: 100) {\n    edges {\n      node {\n        id\n        name\n        unqualifiedName\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment PolicyCriteria_policyCollections on Query {\n  policyCollections(first: 100) {\n    edges {\n      node {\n        id\n        name\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment PolicyCriteria_severities on Query {\n  policySeverityValues(first: 100) {\n    edges {\n      node {\n        id\n        severity\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ResourceCriteria_resourceTypes on Query {\n  resourceCriteriaTypes: resourceTypes(first: 100) {\n    edges {\n      node {\n        qualifiedName\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ResourceCriteria_tagKeys on Query {\n  resourceCriteriaTagKeys: resourceTagKeys(first: 100) {\n    edges {\n      node {\n        key\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ResourceCriteria_tagValues_2yVqzf on Query {\n  resourceCriteriaTagValues: resourceTagValues(first: 100, filterElement: $resourceCriteriaTagValuesFilter) {\n    edges {\n      node {\n        value\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment useResourceMatchCount_query on Query {\n  resourceMatches(first: 1) {\n    pageInfo {\n      total\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dffbe5e6930af2057d1012e0dbd71b71";

export default node;
